// extracted by mini-css-extract-plugin
export default {"topnav":"topnav_topnav__KULD1","logo":"topnav_logo__KeazE","titleWrapper":"topnav_titleWrapper__QwcIG","title":"topnav_title__3vS9t","breadcrumb":"topnav_breadcrumb__LxfeH"};